import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-20 pb-10 md:pt-28 md:pb-16 px-4 bg-gradient-to-b from-cream to-cream-dark overflow-hidden" data-id="element-117">
      <div className="max-w-6xl mx-auto" data-id="element-118">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-119">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-120">
            <div className="inline-block bg-sage/10 text-sage-dark font-bold px-4 py-1.5 rounded-full text-sm mb-4 border border-sage/20" data-id="element-121">
              Protocolo Maestro para Apagar la "Barriga de Cortisol"
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-dark leading-tight mb-4" data-id="element-122">
              Cómo Recuperar tu Cintura y tu Energía en 21 Días{' '}
              <span className="text-sage-dark italic" data-id="element-123">
                Sin Contar una Sola Caloría
              </span>
            </h1>

            <p className="text-base md:text-lg text-dark-light mb-6 font-light leading-relaxed" data-id="element-124">
              Deja de luchar contra tu edad. Descubre el sistema basado en la
              ciencia de 2026 que sustituye la restricción por la{' '}
              <strong className="font-bold text-dark" data-id="element-125">Sinfonía Hormonal</strong>
              .
            </p>

            <ul className="text-left space-y-2 mb-8 max-w-md mx-auto lg:mx-0" data-id="element-126">
              {['Encender tu Metabolismo Hormonal', 'Incluso si sientes que "el aire te engorda"', 'Resultados visibles en 21 días'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.3 + i * 0.1
            }} className="flex items-center gap-3 text-dark-light" data-id="element-127">
                  <CheckCircle2 className="w-5 h-5 text-sage flex-shrink-0" data-id="element-128" />
                  <span data-id="element-129">{item}</span>
                </motion.li>)}
            </ul>

            <Button onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} data-id="element-130">
              SÍ, QUIERO RECUPERAR MI CUERPO — POR SOLO $6.36 (Antes $37)
            </Button>
            <p className="text-sm text-dark-light/70 mt-4 text-center lg:text-left" data-id="element-131">
              📩 Acceso inmediato por email en menos de 5 minutos • Garantía 30
              días
            </p>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex-1 relative w-full max-w-lg lg:max-w-none mx-auto" data-id="element-132">
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full opacity-50 transform -translate-y-10" data-id="element-133"></div>
            <img src="https://cdn.magicpatterns.com/uploads/oa6x9p83qZWWMCJ4qZiHYM/el_codigo_hormonal402B_Mockup.png" alt="El Código Hormonal 40+ Colección Completa" className="relative z-10 w-[70%] h-auto drop-shadow-2xl mx-auto" data-id="element-134" />
          </motion.div>
        </div>
      </div>
    </section>;
}